module.exports = __webpack_public_path__ + "img/DE01512.fb390b88.png";